import React from 'react';

class SceollNav extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        let headerElem = document.querySelector('header');
        let filterElem = document.querySelector('.filter-grid');

        let navbarHeight = headerElem.clientHeight;
        let winHeight;
        let docHeight;

        let didScroll;
        let lastScrollTop = 0;
        let delta = 5;
       
        window.addEventListener('scroll', function() {
            didScroll = 1;
            console.log( );
        });

        setInterval(function() {
            if (didScroll) {
                hasScrolled();
                didScroll = 0;
            }
        }, 250);
        
        function hasScrolled() {
            let st = window.scrollY;
            
            winHeight = document.documentElement.clientHeight;
            docHeight = document.documentElement.scrollHeight;

         
            if(Math.abs(lastScrollTop - st) <= delta)
                return;
            
       
            if (st > lastScrollTop && st > navbarHeight){
                headerElem.classList.add('out-of-window');
                if(filterElem)
                    filterElem.classList.add('out-of-window');
                //console.log('down');
            }
            else {
                // Scroll Up
                if(st + winHeight < docHeight) {
                    headerElem.classList.remove('out-of-window');
                    if(filterElem)
                        filterElem.classList.remove('out-of-window');
                    //console.log('up');
                }
            }
            lastScrollTop = st;
        }
    }

    render() {
        return (
			<span className="d-none"></span>
        );
    }
}

export default SceollNav;


// WEBPACK FOOTER //
// ./src/components/ScrollNav.js